// extracted by css-extract-rspack-plugin
export default {"compactPopover":"z4TSvu4lOuEj6elU","compactPopoverContent":"QAPqNk7f1UT3_88W"};